import { ActionName } from 'api/endpoints/action-names';
import {
  AddFields,
  EditFieldsList,
  EntityTable,
  Panel,
} from 'components/UIComponents/EntityTable';
import { AwarePanel } from 'components/UIComponents/EntityTable/EntityTable.components';
import { SectionType } from 'pages/ClaimsContractsToolPage/types';
import { SettingsContentPanel } from 'pages/SettingsPage/components/SettingsContentPanel';
import './ActionNames.css';
import { ActionNameInput } from './ClaimsActionNameInput';
import { useClaimActionNames } from './useClaimActionNames';
import { filterExistingActionNames } from './utils';

const HEADERS = [
  'Resolution name',
  'Resolution type',
  'Resolution subtype',
  'Hearing Date',
];
const COLUMN_KEYS: (keyof ActionName)[] = [
  'name',
  'typeId',
  'substatusId',
  'hearingDate',
];

export function ActionNames() {
  const { actionNames, onAddSave, onEditSave } = useClaimActionNames();

  return (
    <SettingsContentPanel>
      <section className="actionnames">
        <EntityTable
          items={filterExistingActionNames(actionNames)}
          status={undefined}
          addColumnKeys={COLUMN_KEYS}
          editColumnKeys={COLUMN_KEYS}
          inputComponent={ActionNameInput}
          onEditSave={onEditSave}
          onAddSave={onAddSave}
          section={SectionType.Claims}
        >
          <Panel title="Add a new resolution name">
            <AddFields headers={HEADERS} />
          </Panel>
          <AwarePanel title="Resolution names">
            <EditFieldsList headers={HEADERS} />
          </AwarePanel>
        </EntityTable>
      </section>
    </SettingsContentPanel>
  );
}
